<template>
  <div class="contents buka-edit">
    <h2>部課の新規作成・編集</h2>
    <div class="tabs">
      <scroll-tabs style="width: 100%">
        <ul>
          <li :class="{ active: tab === TAB.BUKA_EDIT }"><a @click="checkBeforeChangeTab(TAB.BUKA_EDIT)">部課情報</a></li>
          <li :class="{ active: tab === TAB.SYUUGYOU_BASYO_EDIT }"><a
              @click="checkBeforeChangeTab(TAB.SYUUGYOU_BASYO_EDIT)">部課に属する就業場所の設定</a>
          </li>
        </ul>
      </scroll-tabs>
    </div><!-- /tabs -->

    <div class="tab-container">
      <BukaEditForm v-if="tab === TAB.BUKA_EDIT"></BukaEditForm>
      <SyuugyouBasyoEditForm v-if="tab === TAB.SYUUGYOU_BASYO_EDIT"></SyuugyouBasyoEditForm>
    </div>

    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.MST_BUKA_SEARCH,
        }">戻る
        </router-link>
      </p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, ref } from 'vue'
import { RouterConst } from '@/const/Router'
import { useTab } from '@/composable/common/tab';
import BukaEditForm from '@/components/master/buka/parts/BukaEditForm.vue';
import SyuugyouBasyoEditForm from '@/components/master/buka/parts/SyuugyouBasyoEditForm.vue';
import { useRoute } from 'vue-router';
import { DialogService } from '@/service/DialogService';

export default defineComponent({
  setup() {
    const isLoading = ref(false)
    const { tab, changeTab } = useTab('bukaEdit');

    const TAB = {
      BUKA_EDIT: 'bukaEdit',
      SYUUGYOU_BASYO_EDIT: 'syuugyouBasyoEdit',
    }

    const route = useRoute()

    const checkBeforeChangeTab = async (tabName: string) => {
      const bukaId = parseInt(route.params.bukaId as string, 10);

      if (!bukaId && tab.value === TAB.BUKA_EDIT && tabName === TAB.SYUUGYOU_BASYO_EDIT) {
        await DialogService.error({
          html: '就業場所の設定は部課の作成後のみ可能です。<br>現在の入力内容を保存してから再度お試しください。'
        })
        return
      }

      changeTab(tabName)
    }

    return {
      isLoading,
      RouterConst,
      tab,
      checkBeforeChangeTab,
      TAB
    }
  },
  components: {
    BukaEditForm,
    SyuugyouBasyoEditForm,
  }
})
</script>

<style lang="scss" scoped>
@import "@scss/components/buka-edit.scss";
</style>
